/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import objectPath from "object-path";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { AsideSearch } from "./AsideSearch";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { QuickUserToggler } from "../extras/QuickUserToggler";
import { Brand } from "../brand/Brand";
import { KTUtil } from "./../../../_assets/js/components/util";
import Icon from '@material-ui/core/Icon';
import { AsideHospitalMenu } from "./aside-menu/AsideHospitalMenu";
import { AsideInsuranceMenu } from "./aside-menu/AsideInsuranceMenu";
import { IfHasPermission } from "../../../_helpers";
import { getModulesCounter } from "../../../../app/pages/services/casesService";

export function Aside() {
  const uiService = useHtmlClassService();
  const [modulesCounter, setModulesCounter] = useState({});

  useEffect(() => {
    getModulesCounter().then( response => setModulesCounter(response) );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const layoutProps = useMemo(() => {
    return {
      asideClassesFromConfig: uiService.getClasses("aside", true),
      asideSecondaryDisplay: objectPath.get(
        uiService.config,
        "aside.secondary.display"
      ),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      extrasSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      extrasNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      extrasQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      extrasQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      extrasLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      extrasUserDisplay: objectPath.get(
        uiService.config,
        "extras.user.display"
      ),
    };
  }, [uiService]);

  const tabs = {
    tabId1: "kt_aside_tab_1",
    tabId2: "kt_aside_tab_2",
    tabId3: "kt_aside_tab_3",
    tabId4: "kt_aside_tab_4",
  };
  const [activeTab, setActiveTab] = useState(tabs.tabId1);
  const handleTabChange = (id) => {
    setActiveTab(id);
    const asideWorkspace = KTUtil.find(
      document.getElementById("kt_aside"),
      ".aside-secondary .aside-workspace"
    );
    if (asideWorkspace) {
      KTUtil.scrollUpdate(asideWorkspace);
    }
  };

  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig}`}
      >
        {/* begin::Primary */}
        <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
          <Brand />
          {/* begin::Nav Wrapper */}
          <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
            {/* begin::Nav */}
            <ul className="list-unstyled flex-column" role="tablist">
              {/* begin::Item */}
              <li
                className="nav-item mb-3"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Dashboard"
              >
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="latest-project">Dashboard</Tooltip>
                  }
                >
                  <a
                    href="#"
                    className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab ===
                      tabs.tabId1 && "active"}`}
                    data-toggle="tab"
                    data-target={`#${tabs.tabId1}`}
                    role="tab"
                    onClick={() => handleTabChange(tabs.tabId1)}
                  >
                    <span className="svg-icon svg-icon-lg">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Layout/Layout-4-blocks.svg"
                        )}
                      />
                    </span>
                  </a>
                </OverlayTrigger>
              </li>
              {/* end::Item */}

              
              {/* begin::Item */}
              { IfHasPermission("Hospital") && (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Hospital"
                >
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="latest-project">Hospital</Tooltip>
                    }
                  >
                    <a
                      href="#"
                      className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab ===
                        tabs.tabId3 && "active"}`}
                      data-toggle="tab"
                      data-target={`#${tabs.tabId3}`}
                      role="tab"
                      onClick={() => handleTabChange(tabs.tabId3)}
                    >
                      <Icon className="fa fa-hospital" />
                    </a>
                  </OverlayTrigger>
                </li>
              )}
              {/* end::Item */}

              {/* begin::Item */}
              { IfHasPermission("Aseguradora") && (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Aseguradora"
                >
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="latest-project">Aseguradora</Tooltip>
                    }
                  >
                    <a
                      href="#"
                      className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab ===
                        tabs.tabId4 && "active"}`}
                      data-toggle="tab"
                      data-target={`#${tabs.tabId4}`}
                      role="tab"
                      onClick={() => handleTabChange(tabs.tabId4)}
                    >
                      <Icon className="fa fa-book-medical" />
                    </a>
                  </OverlayTrigger>
                </li>
              )}
              {/* end::Item */}
              
              
              {/* begin::Item */}
              { IfHasPermission("Administracion") && (
                <li
                  className="nav-item mb-3"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Administracion"
                >
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="latest-project">Administracion</Tooltip>
                    }
                  >
                    <a
                      href="#"
                      className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab ===
                        tabs.tabId2 && "active"}`}
                      data-toggle="tab"
                      data-target={`#${tabs.tabId2}`}
                      role="tab"
                      onClick={() => handleTabChange(tabs.tabId2)}
                    >
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Code/Lock-circle.svg"
                          )}
                        />
                      </span>
                    </a>
                  </OverlayTrigger>
                </li>
              )}
              {/* end::Item */}
            </ul>
            {/* end::Nav */}
          </div>
          {/* end::Nav Wrapper */}

          {/* begin::Footer */}
          <div className="aside-footer d-flex flex-column align-items-center flex-column-auto py-4 py-lg-10">
            {/* begin::Aside Toggle */}
            {layoutProps.asideSecondaryDisplay &&
              layoutProps.asideSelfMinimizeToggle && (
                <>
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="toggle-aside">Toggle Aside</Tooltip>}
                  >
                    <span
                      className="aside-toggle btn btn-icon btn-primary btn-hover-primary shadow-sm"
                      id="kt_aside_toggle"
                    >
                      <i className="ki ki-bold-arrow-back icon-sm" />
                    </span>
                  </OverlayTrigger>
                </>
              )}
            {/* end::Aside Toggle */}

            {/* begin::User*/}
            {layoutProps.extrasUserDisplay && <QuickUserToggler />}
            {/* end::User */}

            <div className="d-flex flex-column align-items-center mt-6">
              <img
                alt="Ve por Más"
                src={toAbsoluteUrl("/media/logos/LogoBXM.svg")}
                style={{ height: "22px" }}
              />
              <span
                className="text-muted font-weight-bold mt-2 text-center"
                style={{ fontSize: "0.7rem", lineHeight: "1.1" }}
              >
                ATC Plus
                <br />
                Asegurados BX+
              </span>
            </div>
          </div>
          {/* end::Footer */}
        </div>
        {/* end::Primary */}

        {layoutProps.asideSecondaryDisplay && (
          <>
            {/* begin::Secondary */}
            <div className="aside-secondary d-flex flex-row-fluid">
              {/* begin::Workspace */}
              <div className="aside-workspace scroll scroll-push my-2">
                <div className="tab-content">
                  <AsideSearch isActive={activeTab === tabs.tabId1} />
                  <AsideMenu isActive={activeTab === tabs.tabId2} />
                  <AsideHospitalMenu isActive={activeTab === tabs.tabId3} modulesCounter={modulesCounter} />
                  <AsideInsuranceMenu isActive={activeTab === tabs.tabId4} modulesCounter={modulesCounter} />
                </div>
              </div>
              {/* end::Workspace */}
            </div>
            {/* end::Secondary */}
          </>
        )}
      </div>
      {/* end::Aside */}
    </>
  );
}
